const user = {
  state: () => ({
    userFilled: false,
    userData: {},
    userLoading: true,
  }),
  mutations: {
    updateUserFilled(state, payload) {
      state.userFilled = payload.userFilled;
    },
    updateUserData(state, payload) {
      state.userData = payload.userData;
    },
    updateUserLoading(state, payload) {
      state.userLoading = payload;
    },
  },
  actions: {
    updateUserData(context, params) {
      context.commit('updateUserData', params);
    },
    updateUserLoading(context, params) {
      context.commit('updateUserLoading', params);
    },
  },
};

export default user;
